var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-alert',{staticClass:"max-phone-number__alert",attrs:{"type":"warning","show-icon":"","closable":false}},[_c('p',[_vm._v(_vm._s(_vm.$t('billing.pbx.max_phone_number_desc', [_vm.maxSelectPhoneNumbers])))])])}
var staticRenderFns = []

export { render, staticRenderFns }